import React from 'react'
import {  Box, Grid} from '@mui/material'
import HeaderBox from '../../components/HeaderBox';
import { Typography, Card, CardContent } from '@mui/material';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import MechanicAction from '../../components/Mechanic/MechanicAction';

const boxStyle = {
    root: {
      backgroundColor: 'white', 
      borderRadius: '5px',
      padding: 1
    },
  };
const dataGridStyle = {
    root: {
      "& .MuiDataGrid-root": {
        borderRadius: '10px',
        backgroundColor: 'white',
        fontSize: '15px',
      },
      "& .MuiDataGrid-columnHeaders": {
        color: '#005A9C',
        fontSize: '16px',
      }
    },
};

function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false, flex: 1, minWidth: 100 , },
    { field: 'SNNO', headerName: 'SN NO', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'SNDate', headerName: 'SN Date', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Make', headerName: 'Make', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Model', headerName: 'Model', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'RegNO', headerName: 'Reg NO', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Status', headerName: 'Status', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'StartDate', headerName: 'Start Date', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'EndDate', headerName: 'End Date', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'TotalHours', headerName: 'Total Hours', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
        return (
                <MechanicAction title='Convert To Mechanic Order Update'  page='mechanic_order_update'/>
                );}
    }
    ];
    
     
    
const rows = [
    { id: '1', SNNO: '252', SNDate: '01-02-2023', Make: 'Audi', Model:'A5', RegNO:'CD123', Status:'Work In Progress', StartDate: '01-08-2023', EndDate:'10-08-2023', TotalHours:'' , action:''  },
    { id: '2', SNNO: '253', SNDate: '01-02-2023', Make: 'Bmw', Model:'C5', RegNO:'Tx258', Status:'Allocated', StartDate: '01-08-2023', EndDate:'03-08-2023', TotalHours:'' , action:''  },
    { id: '3', SNNO: '254', SNDate: '01-02-2023', Make: 'Ford', Model:'Fista', RegNO:'BQ012', Status:'Completed', StartDate: '05-08-2023', EndDate:'05-08-2023', TotalHours:'2.5' , action:''  },
    { id: '4', SNNO: '255', SNDate: '01-02-2023', Make: 'Audi', Model:'A5', RegNO:'Q1987', Status:'Allocated', StartDate: '01-08-2023', EndDate:'05-08-2023', TotalHours:'' , action:''  },
    { id: '5', SNNO: '256', SNDate: '01-02-2023', Make: 'Bmw', Model:'C5', RegNO:'SB012', Status:'Allocated', StartDate: '01-08-2023', EndDate:'06-08-2023', TotalHours:'' , action:''  },
    
    ];    


function MechanicHome() {
  return (
    <Box mt={2}>
        <Grid container spacing={1}>
        <Grid item xs={12} >
      <Grid container spacing={1}>
        {/* <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>MECHANIC HOME</Typography>
          </Grid> */}
            </Grid>
            </Grid>
            <Grid item xs={12} mt={1}>
                <Grid item xs={12} >
                    <HeaderBox title='Mechanic Home Dashboard'/>
                </Grid>
                <Box sx={boxStyle.root}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Box sx={boxStyle.root} mt={5}>
                                            <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Card sx={{ width: '100%', height: '80px', borderRadius: '10px' }}>
                                                    <CardContent sx={{ p: '10px' }}>
                                                        <Typography sx={{ color: '#005A9C', fontWeight:'bold',textAlign:'center' }}  gutterBottom>
                                                            Service Order Alloted
                                                        </Typography>
                                                    <   Typography sx={{ fontSize: '20px', color: '#008E97' , fontWeight:'bold', textAlign:'center'}} component="div">
                                                        10
                                                        </Typography>
                                                    </CardContent>
                                                 </Card>   
                                            </Grid> 
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Card sx={{ width: '100%', height: '80px', borderRadius: '10px' }}>
                                                    <CardContent sx={{ p: '10px' }}>
                                                        <Typography sx={{ color: '#005A9C',fontWeight:'bold', textAlign:'center' }}  gutterBottom>
                                                            Service Order Completed
                                                        </Typography>
                                                    <   Typography sx={{ fontSize: '20px', color: '#008E97' , fontWeight:'bold', textAlign:'center'}} component="div">
                                                        8
                                                        </Typography>
                                                    </CardContent>
                                                 </Card>   
                                            </Grid> 
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Card sx={{ width: '100%', height: '80px', borderRadius: '10px' }}>
                                                    <CardContent sx={{ p: '10px' }}>
                                                        <Typography sx={{ color: '#005A9C',fontWeight:'bold', textAlign:'center'}}  gutterBottom>
                                                            Work In Progress
                                                        </Typography>
                                                    <   Typography sx={{ fontSize: '20px', color: '#008E97' , fontWeight:'bold', textAlign:'center'}} component="div">
                                                            2
                                                        </Typography>
                                                    </CardContent>
                                                 </Card>   
                                            </Grid> 
                                            </Grid>
                                        </Box>
                                    </Grid>

                                    
                                    <Grid item xs={12} sm={6} md={12} mt={1}>
                                    <HeaderBox title='Allotted Job Card List'/>
                                        <Grid item xs={12} >
                                            <Box sx={dataGridStyle.root}>
                                                <DataGrid
                                                    columnHeaderHeight={35}
                                                    rowHeight={35}
                                                    rows={rows}
                                                    columns={columns}
                                                    getRowId={(row) => row.id}
                                                    initialState={{ pagination: { paginationModel: { pageSize: 10, }, }, }}
                                                    pageSizeOptions={[10]}
                                                    slots={{ columnMenu: CustomColumnMenu }}
                                                    disableRowSelectionOnClick
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>


                                </Grid>
                            </Grid>
                        </Grid>







                    </form>
                </Box>
            </Grid>
        </Grid>
    </Box>
  )
}

export default MechanicHome